<template>
  <head>
    <meta charset="utf-8" />
    <title>Hotline Transporters Sacco | Create an invoice</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <link href="assets/libs/select2/css/select2.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/bootstrap-datepicker/css/bootstrap-datepicker.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/spectrum-colorpicker2/spectrum.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/bootstrap-timepicker/css/bootstrap-timepicker.min.css" rel="stylesheet" type="text/css">
    <link href="assets/libs/bootstrap-touchspin/jquery.bootstrap-touchspin.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/%40chenfengyuan/datepicker/datepicker.min.css">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- Offender email address -->
    <div class="modal fade " id="subscribeModal" data-backdrop="static" data-keyboard="false" tabindex="-1 " role="dialog " aria-labelledby="staticBackdropLabel " aria-hidden="true ">
      <div class="modal-dialog modal-dialog-centered ">
        <div class="modal-content ">
          <div class="modal-header border-bottom-0 ">
            <button type="button " class="btn-close" data-dismiss="modal"  aria-label="Close "></button>
          </div>
          <div class="modal-body ">
            <div class="text-center mb-4 ">
              <div class="avatar-md mx-auto mb-4 ">
                <div class="avatar-title bg-light rounded-circle text-success h1 ">
                  <i class="bx bx-receipt "></i>
                </div>
              </div>

              <div class="row justify-content-center ">
                <div class="col-xl-10 ">
                  <h4 class="text-primary ">Enter Bill Number To continue</h4>
                  <p class="text-muted font-size-14 mb-4 ">
                    Enter the Bill Numbers's
                    <small>For multiples bill numbers you can separate with a comma at once. e.g Bll0***, Bll041***, Bll0***</small>
                  </p>

                  <form>
                    <div class="row ">
                      <div class="col-12 ">
                        <div class="mb-3 ">
                          <label for="digit1-input " class="visually-hidden ">Bill No.</label>
                          <input v-model="billNo" type="text " class="form-control form-control-lg text-center two-step " placeholder="Search for Bill">
                        </div>
                      </div>
                    </div>
                    <button @click="getBills()" type="button" class="btn btn-success btn-block w-100 " data-dismiss="modal">
                      <i class="bx bx-search-alt-2 font-size-16 align-middle me-2 "></i>
                      Search
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Offender's email address -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div  class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18 text-capitalize">Invoice receipting</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Receipt Bill</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Loading state when auto-searching -->
          <div v-if="autoSearching" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body text-center py-5">
                  <div class="spinner-border text-primary mb-3" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <h5 class="text-muted">Searching for invoice {{ autoSearchBillNo }}...</h5>
                  <p class="text-muted small">Please wait while we fetch the invoice details.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- eTransactions table -->
          <div v-if="!autoSearching" class="row">
            <!-- use this when the selections are empty -->
            <div v-if="invoices.length === 0" class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex text-center align-items-center justify-content-center">
                    <div class="row d-flex text-center align-items-center justify-content-center initial-placeholder-receipting">
                      <div class="col-sm-12 col-lg-6 col-md-6">
                        <div class="p-4 border-radius border-solid border-primary border-2">
                          <div class="img mb-4 pt-3">
                            <img src="assets/images/animatedIcons/icons8-search.gif" class="img" alt="">
                          </div>
                          <div>
                            <h4 class="card-title text-uppercase text-dark">Invoice Receipting</h4>
                            <p>This section allows you to receipt existing bills. Search for unpaid invoices to proceed. You can also use this section to pay for multiple invoices at once.</p>
                            <p class="fw-semibold text-capitalize" >Search For an invoice to continue</p>
                            <button type="button"  data-toggle="modal" data-target="#subscribeModal"  class="btn btn-lg btn-success btn-block w-100 mt-5 mb-3">
                              <i class="bx bx-search-alt-2 font-size-28 align-middle me-2 "></i>
                              Search For Invoice
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end of emptiness -->

            <div v-if="invoices.length !== 0" class="col-12">
              <div class="row d-flex justify-content-center align-items-center">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <div class="p-3 bg-warning bg-soft mb-4 d-flex justify-content-between align-items-center">
                            <h4 class="p-0 m-0 fw-bold text-dark">Invoice Receipting ({{invoices.length}} Invoice(s))</h4>
                            <div class="text-uppercase">
                              <button data-toggle="modal" data-target="#clearModal" type="button" class="btn btn-danger btn-block w-md text-uppercase fw-bold" style="margin-left: 10px;">
                                <i class="bx bx-trash font-size-21 align-middle me-2"></i> Clear
                              </button>
                              <button data-toggle="modal" data-target="#subscribeModal" type="button" title="You can use this if you want to include another invoice to pay along with the one you've already searched for" class="btn btn-primary btn-block w-md text-uppercase fw-bold" style="margin-left: 10px;">
                                <i class="bx bx-folder-plus font-size-21 align-middle me-2"></i> Search To Add
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-3 mb-4">
                          <div class="d-flex">
                            <div class="avatar-sm mx-auto me-3">
                                <span class="avatar-title rounded-circle bg-primary font-21">
                                  <i class="bx bx-receipt text-white"></i>
                                </span>
                            </div>
                            <div class="flex-grow-1">
                              <p class="text-muted mb-0">Selected Invoices</p>
                              <h5 class="mb-0 font-14px">{{invoices.length}}</h5>
                            </div>
                          </div>
                        </div>

                        <div class="col-3 mb-4">
                          <div class="d-flex">
                            <div class="avatar-sm mx-auto me-3">
                                <span class="avatar-title rounded-circle bg-dark font-21">
                                  <i class="mdi mdi-cash-multiple text-white"></i>
                                </span>
                            </div>
                            <div class="flex-grow-1">
                              <p class="text-muted mb-0">Invoice Amount</p>
                              <h5 class="mb-0 font-14px">KES {{formatPrice(totalDetailAmount)}}</h5>
                            </div>
                          </div>
                        </div>

                        <div class="col-3 mb-4">
                          <div class="d-flex">
                            <div class="avatar-sm mx-auto me-3">
                                <span class="avatar-title rounded-circle bg-info font-21">
                                  <i class="mdi mdi-cash-check text-white"></i>
                                </span>
                            </div>
                            <div class="flex-grow-1">
                              <p class="text-muted mb-0">Amount Paid</p>
                              <h5 class="mb-0 font-14px text-uppercase">KES {{formatPrice(totalReceiptAmount)}}</h5>
                            </div>
                          </div>
                        </div>

                        <div class="col-3 mb-4">
                          <div class="d-flex">
                            <div class="avatar-sm mx-auto me-3">
                                <span class="avatar-title rounded-circle bg-danger font-21">
                                  <i class="mdi mdi-cash-remove text-white"></i>
                                </span>
                            </div>
                            <div class="flex-grow-1">
                              <p class="text-muted mb-0">Remaining Balance</p>
                              <h5 class="mb-0 font-14px">KES {{formatPrice(totalBillBalance)}}</h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-4">
                        <div class="table-responsive border-1 mb-3"  v-for="(item, index) in invoices" :value="item" :key="index">
                          <table class="table table-nowrap vertical-align-middle table-bordered">
                            <thead class="table-danger">
                            <tr class="vertical-align-middle">
                              <th style="width: 70px;">{{index+1}}.</th>
                              <th class="text-uppercase" colspan="2">
                                Invoice No:. <span class="fw-bold text-primary">{{item.billDetails.billNo}}</span> | Date: <span class="fw-bold text-primary">{{item.billDetails.dateCreated}}</span>  | Invoice For: <span class="fw-bold text-primary">{{item.billDetails.customerName}}</span>
                              </th>
                              <th class="text-end">
                                <a @click="printBill(item.billDetails.billNo)" href="javascript: void(0);" target="new"  type="button" class="btn btn-info btn-block w-md btn-sm text-uppercase fw-bold" style="margin-left: 10px;">
                                  <i class="bx bx-printer font-size-16 align-middle me-2"></i> Print Invoice
                                </a>
                                <button @click="removeInvoice(index)" data-toggle="modal" data-target="" type="button" class="btn btn-danger btn-block w-md btn-sm text-uppercase fw-bold" style="margin-left: 10px;">
                                  <i class="bx bx-x font-size-16 align-middle me-2"></i> Remove Invoice
                                </button>
                              </th>
                            </tr>
                            </thead>
                            <thead class="bg-light">
                            <tr>
                              <th style="width: 70px;">No.</th>
                              <th colspan="2">Item Description ({{item.billInfo.length}} QTY)</th>
                              <th class="text-end">Amount</th>
                            </tr>
                            </thead>
                            <tfoot class="bg-light text-uppercase table-bordered">
                            <tr>
                              <td></td>
                              <td class="text-right fw-bold text-uppercase" colspan="2">
                                Invoice Sub Total
                              </td>
                              <td class="text-right fw-bold text-uppercase" colspan="2">
                                KES {{item.billDetails.detailAmount}}
                              </td>
                            </tr>
                            <tr class="table-success">
                              <td></td>
                              <td class="text-right fw-bold text-uppercase" colspan="2">
                                Outstanding Balance
                              </td>
                              <td class="border-0 text-end text-right">
                                <h5 class="m-0 text-uppercase fw-bold">KES {{formatPrice(item.billDetails.billBalance)}}</h5>
                              </td>
                            </tr>
                            </tfoot>
                            <tbody>
                            <tr v-for="(item2, index2) in item.billInfo" :value="item" :key="index2">
                              <td>{{index2+1}}</td>
                              <td colspan="2">
                                <p class="mb-0 p-0 m-0">{{item2.feeDescription}} (X{{item2.quantity}})</p>
                              </td>
                              <td class="text-end text-right">KES {{formatPrice(item2.billTotal)}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="d-flex align-items-center justify-content-center w-100 d-none">
                          <button type="button" class="btn btn-lg btn-dark waves-effect waves-light w-100">
                            <i class="mdi mdi-cash-plus font-size-16 align-middle me-2"></i> Search & Add Invoice (Multi Receipting)
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer bg-white py-4 border-top mt-5">
                      <div class="col-12">
                        <div class="p-3 bg-info bg-soft mb-0 d-flex justify-content-between align-items-center">
                          <div>
                            <h4 class="card-title">Selected Invoices Summary</h4>
                            <ul class="pl-3" v-for="(item, index) in invoices" :value="item" :key="index">
                              <li>{{item.billDetails.billNo}} - KES {{item.billDetails.billBalance}}</li>
                            </ul>
                          </div>
                          <div class="text-right">
                            <h4 class="card-title text-uppercase">Total Amount Payable ({{invoices.length}} Invoice(s))</h4>
                            <h2 class="mb-3">KES {{formatPrice(totalBillBalance)}}</h2>
                            <button type="button" data-toggle="modal" data-target="#payment-modal" class="btn btn-primary waves-effect btn-label waves-light fw-bold text-uppercase">
                              <i class="mdi mdi-send label-icon"></i> Receipt Invoice(s)
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Enhanced payment modal with role-based value date and multi-bank support -->
      <div class="modal fade" id="payment-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalCenterTitle" aria-bs-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header d-none">
              <span class="badge badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">Receive Payment</span>
              <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle close-modal" data-dismiss="modal"  aria-label="Close">
                  <span class="avatar-title bg-transparent text-reset font-18px">
                    <i class="bx bx-x"></i>
                  </span>
              </button>
            </div>
            <div class="modal-body">
              <div class="d-flex justify-content-between align-items-center">
                <span class="badge  badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">Receive Payment</span>
                <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle pull-right close-modal" data-dismiss="modal" aria-label="Close">
                    <span class="avatar-title bg-transparent text-reset font-18px">
                      <i class="bx bx-x"></i>
                    </span>
                </button>
              </div>

              <div class="payment-panel-parent">
                <div v-if="paymentPanel" class="text-center payment-active-panel d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
                  <div class="success-image mb-4 pb-4 pt-4">
                    <img src="assets/images/bills.svg" height="200" alt="">
                  </div>
                  <h4 class="text-black fw-bold">{{message}}</h4>
                  <p class="text-muted mb-4">The bill has been created Successfully, you can print the bill or opt to receive payment for this bill.</p>
                  <div class="d-flex w-100 pb-2">
                    <button @click="showPaymentMethod()" type="button" class="btn btn-primary btn-block  me-3 flex-grow-1">
                      <i class="mdi-cash-check mdi font-size-16 align-middle me-2 "></i>
                      Receive Payment
                    </button>
                    <a @click="printBill()" target="_blank" data-dismiss="" type="button" class="btn btn-outline-secondary waves-effect dismin-modal">Print Bill</a>
                  </div>
                </div>

                <div v-if="paymentMethod" class="send-method payment-panel ">
                  <label for="" class="mb-0 pb-0">Payment Method</label>
                  <p><small class="text-muted">How would you like to send this money?</small></p>

                  <div>
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button class="accordion-button fw-medium" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <div class="flex-shrink-0 me-3">
                              <img class="rounded-circle" src="assets/images/users/mpesa.jpg" alt="Mobile Money" height="65">
                            </div>
                            <div class="d-flex flex-column">
                              <p class="m-0 p-0 text-uppercase fw-semibold">MPESA</p>
                              <p class="mb-0 p-0"> <small>A payment request will be sent directly to the customer</small></p>
                            </div>
                          </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                          <div class="accordion-body">
                            <div>
                              <p>
                                A payment request of <strong class="text-black">KES {{totalBillBalance}}</strong> will be sent to the MPESA number you enter below.
                              </p>
                            </div>
                            <div class="form-group">
                              <label for="">MPESA Number</label>
                              <div class="form-floating mb-3">
                                <input v-model="phoneNumber" type="text" class="form-control font-21 text-success form-control-lg" id="phone-input" placeholder="Enter Name">
                                <label for="floatingnameInput">Phone No.</label>
                              </div>
                              <button @click="showTransactionSummary('MPESA')" type="button" class="btn btn-primary btn-block  me-3 flex-grow-1">
                                <i class="mdi-cash-check mdi font-size-16 align-middle me-2 "></i>
                                Send Payment Request
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button class="accordion-button fw-medium collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <div class="flex-shrink-0 me-3">
                              <img class="rounded-circle" src="assets/images/users/money.jpg" alt="Mobile Money" height="65">
                            </div>
                            <div class="d-flex flex-column">
                              <p class="m-0 p-0 text-uppercase fw-semibold">bank Receipting</p>
                              <p class="mb-0 p-0"> <small>Enter the receipt number here to confirm payment for this transaction.</small></p>
                            </div>
                          </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                          <div class="accordion-body">
                            <div class="form-group">
                              <!-- Invoice Amount Display -->
                              <div class="alert alert-info mb-3">
                                <div class="d-flex justify-content-between align-items-center">
                                  <span><i class="mdi mdi-receipt me-2"></i>Invoice Balance:</span>
                                  <strong class="font-21">KES {{ formatPrice(totalBillBalance) }}</strong>
                                </div>
                              </div>

                              <!-- Bank Transactions List -->
                              <label for="" class="fw-semibold mb-2">
                                <i class="mdi mdi-bank me-1"></i>
                                Bank Transaction References
                                <span class="badge bg-primary ms-2">{{ bankTransactions.length }}</span>
                              </label>

                              <!-- Existing Bank Transactions -->
                              <div v-if="bankTransactions.length > 0" class="bank-transactions-list mb-3">
                                <div v-for="(txn, idx) in bankTransactions" :key="idx" class="bank-transaction-item border rounded p-3 mb-2">
                                  <div class="d-flex justify-content-between align-items-start">
                                    <div class="flex-grow-1">
                                      <div class="d-flex align-items-center mb-1">
                                        <span class="badge bg-secondary me-2">{{ idx + 1 }}</span>
                                        <strong class="text-primary">{{ txn.refNo }}</strong>
                                      </div>
                                      <div class="small">
                                        <span v-if="txn.validated && txn.amount" class="text-success">
                                          <i class="mdi mdi-check-circle me-1"></i>
                                          KES {{ formatPrice(txn.amount) }}
                                          <span v-if="txn.description" class="text-muted ms-2">- {{ txn.description }}</span>
                                        </span>
                                        <span v-else-if="txn.validating" class="text-info">
                                          <i class="spinner-border spinner-border-sm me-1"></i>
                                          Validating...
                                        </span>
                                        <span v-else-if="txn.error" class="text-danger">
                                          <i class="mdi mdi-alert-circle me-1"></i>
                                          {{ txn.error }}
                                        </span>
                                      </div>
                                    </div>
                                    <button @click="removeBankTransaction(idx)" class="btn btn-sm btn-outline-danger" title="Remove">
                                      <i class="mdi mdi-close"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <!-- Add New Bank Transaction -->
                              <div class="add-bank-transaction border rounded p-3 bg-light">
                                <label class="small text-muted mb-2">Add Bank Reference</label>
                                <div class="input-group">
                                  <input
                                      v-model="newBankRefNo"
                                      type="text"
                                      class="form-control"
                                      placeholder="Enter Bank Ref No. (e.g., CB0740968251208)"
                                      @keyup.enter="addBankTransaction"
                                  >
                                  <button
                                      @click="addBankTransaction"
                                      class="btn btn-primary"
                                      type="button"
                                      :disabled="!newBankRefNo || isValidatingNewRef"
                                  >
                                    <i v-if="isValidatingNewRef" class="spinner-border spinner-border-sm me-1"></i>
                                    <i v-else class="mdi mdi-plus me-1"></i>
                                    Add
                                  </button>
                                </div>
                                <small class="text-muted mt-1 d-block">
                                  <i class="mdi mdi-information-outline me-1"></i>
                                  You can add multiple bank references if the payment was split across transactions.
                                </small>
                              </div>

                              <!-- Totals Summary -->
                              <div v-if="bankTransactions.length > 0" class="totals-summary mt-3 p-3 border rounded">
                                <div class="row">
                                  <div class="col-6">
                                    <div class="d-flex justify-content-between mb-2">
                                      <span class="text-muted">Invoice Balance:</span>
                                      <strong>KES {{ formatPrice(totalBillBalance) }}</strong>
                                    </div>
                                    <div class="d-flex justify-content-between mb-2">
                                      <span class="text-muted">Total Bank Refs:</span>
                                      <strong :class="totalBankAmount === parseFloat(totalBillBalance) ? 'text-success' : 'text-warning'">
                                        KES {{ formatPrice(totalBankAmount) }}
                                      </strong>
                                    </div>
                                    <hr class="my-2">
                                    <div class="d-flex justify-content-between">
                                      <span class="text-muted">Difference:</span>
                                      <strong :class="amountDifference === 0 ? 'text-success' : 'text-danger'">
                                        KES {{ formatPrice(Math.abs(amountDifference)) }}
                                        <span v-if="amountDifference > 0">(Short)</span>
                                        <span v-else-if="amountDifference < 0">(Excess)</span>
                                        <span v-else><i class="mdi mdi-check-circle"></i></span>
                                      </strong>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <!-- Status Indicator -->
                                    <div class="text-center h-100 d-flex flex-column justify-content-center">
                                      <div v-if="allTransactionsValidated && amountDifference <= 0.01 && amountDifference >= -0.01" class="text-success">
                                        <i class="mdi mdi-check-circle-outline font-size-48"></i>
                                        <p class="mb-0 fw-semibold">Amounts Match!</p>
                                        <small class="text-muted">Ready to proceed</small>
                                      </div>
                                      <div v-else-if="allTransactionsValidated && amountDifference < -0.01" class="text-success">
                                        <i class="mdi mdi-check-circle-outline font-size-48"></i>
                                        <p class="mb-0 fw-semibold">Ready to Proceed</p>
                                        <small class="text-warning">Excess KES {{ formatPrice(Math.abs(amountDifference)) }} will be credited</small>
                                      </div>
                                      <div v-else-if="!allTransactionsValidated" class="text-warning">
                                        <i class="mdi mdi-clock-outline font-size-48"></i>
                                        <p class="mb-0 fw-semibold">Validating...</p>
                                        <small class="text-muted">Please wait</small>
                                      </div>
                                      <div v-else-if="amountDifference > 0.01" class="text-warning">
                                        <i class="mdi mdi-alert-outline font-size-48"></i>
                                        <p class="mb-0 fw-semibold">Amount Short</p>
                                        <small class="text-muted">Add more bank references</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Value Date Section - Only for Bank Receipting -->
                              <div v-if="canSetValueDate && bankTransactions.length > 0" class="value-date-section mt-3">
                                <div class="alert alert-info alert-sm" role="alert">
                                  <i class="mdi mdi-information-outline me-2"></i>
                                  You can set a custom value date for this transaction.
                                </div>

                                <div class="form-group">
                                  <label for="bankValueDate" class="form-label fw-semibold">
                                    <i class="mdi mdi-calendar-clock me-1"></i>
                                    Value Date
                                    <span class="text-danger">*</span>
                                  </label>
                                  <div class="input-group">
                                    <input
                                        v-model="paymentData.valueDate"
                                        type="date"
                                        class="form-control"
                                        id="bankValueDate"
                                        :max="getCurrentDate()"
                                        required
                                    >
                                    <button
                                        @click="setTodayAsValueDate()"
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        title="Set today as value date"
                                    >
                                      <i class="mdi mdi-calendar-today"></i>
                                    </button>
                                  </div>
                                  <div class="form-text">
                                    <small class="text-muted">
                                      <i class="mdi mdi-information-outline me-1"></i>
                                      Value date cannot be in the future. Leave empty to use current date.
                                    </small>
                                  </div>

                                  <!-- Value date validation message -->
                                  <div v-if="valueDateError" class="text-danger mt-1">
                                    <small><i class="mdi mdi-alert-circle me-1"></i>{{ valueDateError }}</small>
                                  </div>
                                </div>

                                <!-- Value date summary -->
                                <div v-if="paymentData.valueDate" class="bg-light p-2 rounded mt-2">
                                  <small class="text-muted">
                                    <i class="mdi mdi-calendar-check me-1"></i>
                                    <strong>Selected Value Date:</strong> {{ formatDisplayDate(paymentData.valueDate) }}
                                    <span v-if="isBackdatedTransaction" class="badge badge-warning ms-2">
                                        <i class="mdi mdi-clock-alert me-1"></i>Backdated
                                      </span>
                                  </small>
                                </div>
                              </div>

                              <!-- Validation Messages -->
                              <div v-if="bankValidationMessage && bankTransactions.length === 0"
                                   :class="['alert mt-3', bankValidationStatus === 'success' ? 'alert-success' : bankValidationStatus === 'error' ? 'alert-danger' : 'alert-warning']"
                                   role="alert">
                                <i :class="['mdi', 'me-2', bankValidationStatus === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle']"></i>
                                {{bankValidationMessage}}
                              </div>

                              <div v-if="alert.success" class="alert alert-success mt-3" role="alert">
                                {{message}}
                              </div>

                              <div v-if="alert.info" class="alert alert-primary mt-3" role="alert">
                                {{message}}
                              </div>

                              <div v-if="alert.failed" class="alert alert-danger mt-3" role="alert">
                                {{message}}
                              </div>

                              <!-- Continue Button -->
                              <button
                                  @click="showTransactionSummary('BANK')"
                                  :disabled="!canProceedWithBank"
                                  :class="['btn', 'w-100', 'mt-3', 'btn-bank', canProceedWithBank ? 'btn-success' : 'btn-secondary']"
                              >
                                  <span v-if="!canProceedWithBank">
                                    <i class="mdi mdi-lock me-2"></i>
                                    {{ bankButtonText }}
                                  </span>
                                <span v-else-if="amountDifference < -0.01">
                                    <i class="mdi mdi-check-circle me-2"></i>
                                    Continue (Excess KES {{ formatPrice(Math.abs(amountDifference)) }} will be credited)
                                  </span>
                                <span v-else>
                                    <i class="mdi mdi-check-circle me-2"></i>
                                    Continue with {{ bankTransactions.length }} Transaction(s)
                                  </span>
                              </button>

                              <!-- Additional help text for disabled button -->
                              <div v-if="!canProceedWithBank && !isPrivilegedUser" class="text-muted small mt-2">
                                <i class="mdi mdi-information-outline me-1"></i>
                                {{ bankHelpText }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="transactionSummary" class="transaction-summary payment-panel">
                  <label for="">Transaction Breakdown</label>
                  <div class="border p-4 rounded ">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="text-muted ">
                          Bill NO.
                        </div>
                      </div>
                      <div class="col-lg-6 align-self-end">
                        <div class=" text-right text-black">
                          {{billNumbers}}
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="text-muted mt-2">
                          Payment Method
                        </div>
                      </div>
                      <div class="col-lg-6 align-self-end">
                        <div class=" text-right text-black">
                          {{paymentData.paymentMode}}
                        </div>
                      </div>

                      <!-- Bank Transactions List in Summary -->
                      <div v-if="paymentData.paymentMode === 'BANK' && bankTransactions.length > 0" class="col-12 mt-3">
                        <div class="text-muted mb-2">
                          <i class="mdi mdi-bank me-1"></i>
                          Bank Transactions ({{ bankTransactions.length }})
                        </div>
                        <div class="table-responsive">
                          <table class="table table-sm table-bordered mb-0">
                            <thead class="table-light">
                            <tr>
                              <th>#</th>
                              <th>Reference No.</th>
                              <th class="text-end">Amount</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(txn, idx) in bankTransactions" :key="idx">
                              <td>{{ idx + 1 }}</td>
                              <td>{{ txn.refNo }}</td>
                              <td class="text-end">KES {{ formatPrice(txn.amount) }}</td>
                            </tr>
                            </tbody>
                            <tfoot class="table-secondary">
                            <tr>
                              <th colspan="2">Total</th>
                              <th class="text-end">KES {{ formatPrice(totalBankAmount) }}</th>
                            </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>

                      <!-- Value Date Display in Summary - Only for Bank payments -->
                      <div v-if="canSetValueDate && paymentData.valueDate && paymentData.paymentMode === 'BANK'" class="col-lg-6 mt-2">
                        <div class="text-muted">
                          <i class="mdi mdi-calendar-clock me-1"></i>
                          Value Date
                        </div>
                      </div>
                      <div v-if="canSetValueDate && paymentData.valueDate && paymentData.paymentMode === 'BANK'" class="col-lg-6 align-self-end mt-2">
                        <div class=" text-right text-black">
                          {{ formatDisplayDate(paymentData.valueDate) }}
                          <span v-if="isBackdatedTransaction" class="badge badge-warning ms-1">
                              <i class="mdi mdi-clock-alert me-1"></i>Backdated
                            </span>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="text-muted mt-2">
                          Transaction Amount
                        </div>
                      </div>
                      <div class="col-lg-6 align-self-end">
                        <div class=" text-right text-black">
                          KES {{totalBillBalance}}
                        </div>
                      </div>

                      <div class="col-12 text-black"><hr class="mb-0 pb-0"></div>

                      <div class="col-lg-6 text-uppercase">
                        <div class="text-muted mt-2 font-21">
                          Total
                        </div>
                      </div>
                      <div class="col-lg-6 align-self-end text-uppercase">
                        <div class=" text-right text-black font-21 fw-bold">
                          KES {{totalBillBalance}}
                        </div>
                      </div>
                    </div>

                    <div class="mpesa-confirmation ">
                      <div v-if="paymentData.paymentMode==='MPESA'">
                        <p class="text-muted mt-2">A payment request of <strong class="text-black">KES {{totalBillBalance}}</strong> will be sent to <strong class="text-black"> phone number ({{ phoneNumber }})</strong> soon after you click the <strong class="text-black text-capitalize">Send Request</strong> button bellow.
                          <br>
                          <br>
                          Remember to <strong class="text-black">Check your phone</strong> to confirm payment by entering your Mpesa pin.</p>
                      </div>

                      <div v-if="paymentData.paymentMode==='BANK'" class="alert alert-info mt-3">
                        <i class="mdi mdi-bank me-2"></i>
                        <strong>{{ bankTransactions.length }} Bank Transaction(s)</strong> will be processed sequentially.
                        <div class="small mt-1">
                          Total Amount: <strong>KES {{ formatPrice(totalBankAmount) }}</strong>
                        </div>
                      </div>

                      <div v-if="message" class="alert alert-warning mt-3" role="alert">
                        {{message}}
                      </div>

                      <!-- Processing Progress -->
                      <div v-if="isProcessingMultiplePayments" class="processing-progress mt-3">
                        <div class="alert alert-primary">
                          <div class="d-flex align-items-center mb-2">
                            <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                            <strong>Processing Payments...</strong>
                          </div>
                          <div class="progress mb-2" style="height: 20px;">
                            <div
                                class="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                :style="{ width: processingProgress + '%' }"
                            >
                              {{ currentProcessingIndex + 1 }} / {{ bankTransactions.length }}
                            </div>
                          </div>
                          <small>
                            Processing: <strong>{{ bankTransactions[currentProcessingIndex]?.refNo }}</strong>
                            <span v-if="currentProcessingStatus"> - {{ currentProcessingStatus }}</span>
                          </small>
                        </div>
                      </div>

                      <br>
                      <button
                          @click="makePayment()"
                          :disabled="!isValidForPayment || isProcessingMultiplePayments"
                          class="btn btn-primary btn-flex flex-grow-1 waves-effect btn-send waves-light text-center w-100"
                      >
                        <div class="d-flex justify-content-center align-items-center">
                          <div v-if="isProcessingMultiplePayments" class="me-2">
                            <div class="spinner-border spinner-border-sm" role="status"></div>
                          </div>
                          <div class="stk-timer-container d-none justify-content-center align-items-center">
                            <span class="mdi mdi-timer-outline font-16px"></span>
                            <span class="stk-timer px-2"></span>
                          </div>
                          <div class="justify-content-center align-items-center d-flex">
                            <span class="px-2">{{ isProcessingMultiplePayments ? 'Processing...' : 'Send Request' }}</span>
                            <div v-if="!isProcessingMultiplePayments" class="flip-x"><i class="mdi mdi-reply ms-3 font-16px"></i></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>

                <div v-if="transactionCompleted" class="text-center d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
                  <div class="success-image mb-4">
                    <img src="assets/images/payment-confirmation-images/sent.svg" height="200" alt="">
                  </div>
                  <h4 class="text-blink-primary fw-bold">Transaction Complete</h4>
                  <p class="text-muted mb-4"><strong class="text-black">KES {{receiptDetails.receiptAmount}}</strong> has been received for <strong class="text-black">Bill No. {{receiptDetails.billNo}}</strong></p>

                  <!-- Multi-payment completion summary -->
                  <div v-if="completedPayments.length > 1" class="completed-payments-summary w-100 mb-3">
                    <div class="alert alert-success">
                      <h6 class="mb-2"><i class="mdi mdi-check-circle me-1"></i> All {{ completedPayments.length }} Payments Processed</h6>
                      <div class="table-responsive">
                        <table class="table table-sm mb-0">
                          <thead>
                          <tr>
                            <th>#</th>
                            <th>Reference</th>
                            <th>Receipt No.</th>
                            <th class="text-end">Amount</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(payment, idx) in completedPayments" :key="idx">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ payment.refNo }}</td>
                            <td>{{ payment.receiptNo }}</td>
                            <td class="text-end">KES {{ formatPrice(payment.amount) }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Display value date in completion if backdated and bank payment -->
                  <div v-if="paymentData.valueDate && isBackdatedTransaction && paymentData.paymentMode === 'BANK'" class="alert alert-info mb-3">
                    <small>
                      <i class="mdi mdi-calendar-clock me-1"></i>
                      <strong>Value Date:</strong> {{ formatDisplayDate(paymentData.valueDate) }}
                      <span class="badge badge-warning ms-2">Backdated Transaction</span>
                    </small>
                  </div>

                  <button @click="printReceipt()" type="button" class="btn btn-primary btn-block  me-3 flex-grow-1">
                    <i class="mdi-cash-check mdi font-size-16 align-middle me-2 "></i>
                    Print Receipt
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-footer d-flex d-none bill-modal-footer">
              <button href="javascript: void(0);" disabled class="btn btn-outline-light waves-effect waves-light payment-prev"> <i class="mdi mdi-arrow-left ms-1"></i>Previous</button>
              <button href="javascript: void(0);" class="btn btn-primary waves-effect waves-light payment-next">Next <i class="mdi mdi-arrow-right ms-1"></i></button>
              <button href="javascript: void(0);" class="btn btn-primary btn-flex flex-grow-1 waves-effect waves-light text-center d-none">
                <div class="d-flex justify-content-center align-items-center"> <span>Send Money</span> <div class="flip-x"><i class="mdi mdi-reply flip-x ms-3 font-16px"></i></div></div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of payment modal -->

      <!-- delete modal -->
      <div class="modal fade" id="clearModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content pt-4">
            <div class="modal-body ">
              <div class="text-center mb-4 ">
                <div class="d-flex pb-4 align-items-center justify-content-center">
                  <div>
                    <img src="assets/images/animatedIcons/icons8-list-is-empty.gif" class="img" alt="">
                  </div>
                </div>
                <div class="row justify-content-center ">
                  <div class="col-xl-10 ">
                    <h4 class="text-primary text-uppercase">Start Afresh</h4>
                    <p class="text-muted font-size-14 mb-4 ">
                      Are you sure you want to clear the previously searched invoices and start afresh?
                    </p>
                    <form>
                      <div class="d-flex justify-content-between">
                        <button @click="clearInvoices()" type="button" class="btn btn-danger btn-block w-100" data-dismiss="modal">
                          Clear Selections
                        </button>
                        <button type="button" class="btn btn btn-outline-secondary waves-effect btn-block w-100" data-dismiss="modal">
                          Close
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end of delete modal -->

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 "></div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block "></div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import {biller, execute, getRight, parking, rent, trade} from "@/api";

export default {
  name: "BulkReceipts",
  components: {NavigationBar},
  data(){
    return{
      alert:{
        success: false,
        info: false,
        failed:false
      },
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      billNumbers:'',
      totalBillBalance: '0',
      totalReceiptAmount: '0',
      totalDetailAmount: '0',
      confirmCash: false,
      phoneNumber:'',
      transactionCompleted: false,
      transactionSummary: false,
      paymentPanel: true,
      paymentMethod: false,

      // Auto-search state
      autoSearching: false,
      autoSearchBillNo: '',
      autoSearchProcessed: false,

      // Payment timeout control
      timer: null,
      paymentCheckStartTime: null,
      paymentTimeoutDuration: 35000,
      isCheckingPayment: false,

      // Bank validation states (legacy - kept for single transaction compatibility)
      bankValidationChecking: false,
      bankValidationMessage: '',
      bankValidationStatus: '',
      reconAmount: null,
      isPrivilegedUser: false,
      bankSearchTimeout: null,

      // NEW: Multi-bank transaction support
      bankTransactions: [], // Array of { refNo, amount, description, validated, validating, error, reconData }
      newBankRefNo: '',
      isValidatingNewRef: false,

      // NEW: Multi-payment processing state
      isProcessingMultiplePayments: false,
      currentProcessingIndex: 0,
      currentProcessingStatus: '',
      completedPayments: [], // Array of { refNo, receiptNo, amount }

      // Enhanced payment data with value date
      paymentData: {
        eCitizenReceiptNo: null,
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode: null,
        sessionIdNo: null,
        sessionPhoneNumber: null,
        sessionNames: null,
        valueDate: null
      },

      // Role-based access control
      canSetValueDate: false,

      // Value date validation
      valueDateError: null,

      billNo:'',
      billDetails:{
        id: "",
        billNo: "",
        incomeTypeID: "",
        incomeTypeDescription: "",
        costCenterNo: "",
        accountNo: ",",
        description: "",
        feeID: "",
        detailAmount: "",
        receiptAmount: "",
        billBalance: "",
        wardID: "",
        subCountyID: "",
        status: "",
        dateCreated: ""
      },
      billInfo:[],
      message:null,
      invoices:[],
      receiptDetails: {
        id: '',
        receiptNo: null,
        billNo: '',
        detailAmount: '',
        receiptAmount: '',
        billBalance: '',
        costCenterNo: '',
        accountNo: '',
        incomeTypeDescription: '',
        feeID: '',
        wardID: '',
        subCountyID:'',
        currency: '',
        source: '',
        transactionCode: '',
        paidBy: '',
        dateCreated: '',
        dateModified: '',
        createdBy: '',
        modifiedBy: '',
        isActive: '',
        status: ''
      },
      ReconTransactions: [],
      receiptInfos: []
    }
  },

  beforeUnmount() {
    this.stopPaymentCheck();
    this.clearBankSearchTimeout();
  },

  beforeDestroy() {
    this.stopPaymentCheck();
    this.clearBankSearchTimeout();
  },

  computed: {
    isBackdatedTransaction() {
      if (!this.paymentData.valueDate) return false;
      const valueDate = new Date(this.paymentData.valueDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return valueDate < today;
    },

    isValidForPayment() {
      if (this.isProcessingMultiplePayments) return false;
      if (this.canSetValueDate && this.paymentData.valueDate && this.paymentData.paymentMode === "BANK") {
        return !this.valueDateError;
      }
      return true;
    },

    // NEW: Calculate total amount from all bank transactions
    totalBankAmount() {
      return this.bankTransactions.reduce((sum, txn) => {
        return sum + (parseFloat(txn.amount) || 0);
      }, 0);
    },

    // NEW: Calculate difference between invoice and bank transactions
    amountDifference() {
      const invoiceAmount = parseFloat(this.totalBillBalance) || 0;
      return invoiceAmount - this.totalBankAmount;
    },

    // NEW: Check if all transactions are validated
    allTransactionsValidated() {
      if (this.bankTransactions.length === 0) return false;
      return this.bankTransactions.every(txn => txn.validated && !txn.validating && !txn.error);
    },

    // NEW: Processing progress percentage
    processingProgress() {
      if (this.bankTransactions.length === 0) return 0;
      return ((this.currentProcessingIndex + 1) / this.bankTransactions.length) * 100;
    },

    canProceedWithBank() {
      // Check if user has statusCode "2" privilege
      if (this.isPrivilegedUser) {
        return this.bankTransactions.length > 0;
      }

      // Normal validation for other users
      if (this.bankTransactions.length === 0) {
        return false;
      }

      // All transactions must be validated
      if (!this.allTransactionsValidated) {
        return false;
      }

      // Total amount must be >= invoice balance (exact match or overpayment)
      // Overpayment will be credited to the payer's account by backend
      return this.amountDifference <= 0.01; // Allow if equal or excess
    },

    bankButtonText() {
      if (this.bankTransactions.length === 0) {
        return 'Add Bank Reference(s)';
      }
      if (!this.allTransactionsValidated) {
        return 'Validating References...';
      }
      if (this.amountDifference > 0.01) {
        return `Amount Short by KES ${this.formatPrice(this.amountDifference)}`;
      }
      if (this.amountDifference < -0.01) {
        return `Continue (Excess KES ${this.formatPrice(Math.abs(this.amountDifference))} will be credited)`;
      }
      return 'Continue';
    },

    bankHelpText() {
      if (this.bankTransactions.length === 0) {
        return 'Please add at least one bank reference number to continue.';
      }
      if (!this.allTransactionsValidated) {
        return 'Please wait for all bank references to be validated.';
      }
      if (this.amountDifference > 0.01) {
        return `The total bank references (KES ${this.formatPrice(this.totalBankAmount)}) is less than the invoice amount (KES ${this.formatPrice(this.totalBillBalance)}). Add more bank references to cover the balance.`;
      }
      if (this.amountDifference < -0.01) {
        return `The excess amount of KES ${this.formatPrice(Math.abs(this.amountDifference))} will be credited to the payer's account.`;
      }
      return '';
    }
  },

  watch: {
    'paymentData.valueDate': function(newVal) {
      this.validateValueDate(newVal);
    }
  },

  mounted() {
    this.menuAccess();
    this.checkUserPermissions();
    this.setDefaultValueDate();
    console.log('BulkReceipts mounted, route query:', this.$route.query);
    this.checkForPassedBillNo();
  },

  methods:{
    // Check for billNo passed via query parameter
    checkForPassedBillNo() {
      const billNo = this.$route.query.billNo;
      console.log('Checking for passed billNo:', billNo);
      if (billNo && !this.autoSearchProcessed) {
        this.handlePassedBillNo(billNo);
      }
    },

    handlePassedBillNo(billNo) {
      console.log('Handling passed billNo:', billNo);
      this.autoSearchProcessed = true;
      this.autoSearching = true;
      this.autoSearchBillNo = billNo;
      this.billNo = billNo;
      this.invoices = [];

      this.processBillWithCallback(billNo, () => {
        this.autoSearching = false;
        console.log('Auto-search completed for:', billNo);
      });
    },

    processBillWithCallback(billNo, callback) {
      console.log('Processing bill:', billNo);
      if(billNo === '' || !billNo){
        this.autoSearching = false;
        if (callback) callback();
        return;
      }

      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller)
          .then((res) => {
            console.log('Bill response:', res.data);
            this.billInfo = [];
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails;
              this.billInfo = res.data.data.billInfo;
              const invoiceExists = this.invoices.some(invoice => invoice.billDetails.id === res.data.data.billDetails.id);
              if (!invoiceExists) {
                this.invoices.push(res.data.data);
                console.log('Invoice added, total invoices:', this.invoices.length);
              }
              this.totalsInvoicesSummary();
            } else {
              this.message = res.data.message;
              console.error('Invoice not found:', res.data.message);
            }
            if (callback) callback();
          })
          .catch((e) => {
            this.message = e.message;
            console.error('Error fetching invoice:', e.message);
            if (callback) callback();
          });
    },

    // Payment timeout control methods
    startPaymentCheck() {
      this.stopPaymentCheck();
      this.paymentCheckStartTime = Date.now();
      this.isCheckingPayment = true;
      this.timer = setInterval(() => {
        this.checkPayment();
      }, 3000);
    },

    stopPaymentCheck() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.isCheckingPayment = false;
      this.paymentCheckStartTime = null;
    },

    clearBankSearchTimeout() {
      if (this.bankSearchTimeout) {
        clearTimeout(this.bankSearchTimeout);
        this.bankSearchTimeout = null;
      }
    },

    handlePaymentTimeout() {
      this.stopPaymentCheck();
      this.message = "Payment check timed out. Please check your payment status manually or try again.";
      this.showPaymentTimeoutOptions();
    },

    showPaymentTimeoutOptions() {
      const userChoice = confirm(
          "Payment verification timed out. Would you like to:\n" +
          "OK - Check payment status manually\n" +
          "Cancel - Return to payment method selection"
      );

      if (userChoice) {
        this.checkPaymentManually();
      } else {
        this.resetToPaymentMethod();
      }
    },

    checkPaymentManually() {
      this.message = "Checking payment status...";

      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.handlePaymentSuccess(res);
            } else {
              this.message = "Payment not found. Please try again or contact support.";
              setTimeout(() => {
                this.resetToPaymentMethod();
              }, 3000);
            }
          })
          .catch((e) => {
            this.message = "Error checking payment status. Please try again.";
            console.error("Manual payment check error:", e.message);
            setTimeout(() => {
              this.resetToPaymentMethod();
            }, 3000);
          });
    },

    resetToPaymentMethod() {
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;
      this.message = null;
      this.isProcessingMultiplePayments = false;
      this.currentProcessingIndex = 0;
      this.currentProcessingStatus = '';
    },

    handlePaymentSuccess(res) {
      this.message = null;
      this.stopPaymentCheck();
      this.receipt = true;
      this.paymentData.success = false;
      this.transaction = res.data.data.transaction;
      this.receiptDetails = res.data.data.receipt.receiptDetails;
      this.transactionSummary = false;
      this.transactionCompleted = true;
    },

    checkUserPermissions() {
      this.canSetValueDate = this.getRight('BANK RECEIPTING VALUE DATE');
      this.isPrivilegedUser = sessionStorage.getItem("statusCode") === "2";
      console.log('Can set value date:', this.canSetValueDate);
      console.log('Is privileged user:', this.isPrivilegedUser);
    },

    setDefaultValueDate() {
      if (this.canSetValueDate) {
        this.paymentData.valueDate = this.getCurrentDate();
      }
    },

    getCurrentDate() {
      const today = new Date();
      return today.toISOString().split('T')[0];
    },

    setTodayAsValueDate() {
      this.paymentData.valueDate = this.getCurrentDate();
    },

    formatDisplayDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    validateValueDate(valueDate) {
      this.valueDateError = null;

      if (!valueDate) return;

      const selectedDate = new Date(valueDate);
      const today = new Date();
      today.setHours(23, 59, 59, 999);

      if (selectedDate > today) {
        this.valueDateError = 'Value date cannot be in the future';
        return;
      }

      const maxBackdateMonths = 6;
      const maxBackdateDate = new Date();
      maxBackdateDate.setMonth(maxBackdateDate.getMonth() - maxBackdateMonths);

      if (selectedDate < maxBackdateDate) {
        this.valueDateError = `Value date cannot be more than ${maxBackdateMonths} months in the past`;
        return;
      }
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Receipts New");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type){
      return getRight(type)
    },

    formatPrice(value) {
      const val = parseFloat(value) || 0;
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(val);
    },

    removeInvoice(index) {
      this.invoices.splice(index, 1);
      this.totalsInvoicesSummary()
    },

    // NEW: Add bank transaction
    async addBankTransaction() {
      const refNo = this.newBankRefNo.trim();
      if (!refNo) {
        alert('Please enter a bank reference number');
        return;
      }

      // Check for duplicates
      if (this.bankTransactions.some(txn => txn.refNo === refNo)) {
        alert('This reference number has already been added');
        return;
      }

      this.isValidatingNewRef = true;

      // Add to list with validating state
      const newTxn = {
        refNo: refNo,
        amount: null,
        description: null,
        validated: false,
        validating: true,
        error: null,
        reconData: null
      };
      this.bankTransactions.push(newTxn);
      this.newBankRefNo = '';

      // Validate the transaction
      await this.validateBankTransaction(this.bankTransactions.length - 1);
      this.isValidatingNewRef = false;
    },

    // NEW: Validate a bank transaction
    async validateBankTransaction(index) {
      const txn = this.bankTransactions[index];
      if (!txn) return;

      txn.validating = true;
      txn.error = null;

      const data = new FormData();
      data.append("function", "getReconciledRecords");
      data.append("page", 1);
      data.append("rows_per_page", 10);
      data.append("search", txn.refNo);
      data.append("preciseSearch", true);

      try {
        const res = await execute(data, biller);

        if (res.data.success && res.data.data.ReconTransactions && res.data.data.ReconTransactions.length > 0) {
          const reconRecord = res.data.data.ReconTransactions[0];
          txn.amount = parseFloat(reconRecord.amount);
          txn.description = reconRecord.description;
          txn.validated = true;
          txn.reconData = reconRecord;
          txn.error = null;
        } else {
          txn.validated = false;
          txn.error = 'Reference not found in bank records';
        }
      } catch (e) {
        txn.validated = false;
        txn.error = e.message || 'Error validating reference';
      } finally {
        txn.validating = false;
      }
    },

    // NEW: Remove bank transaction
    removeBankTransaction(index) {
      this.bankTransactions.splice(index, 1);
    },

    // Legacy method - kept for backward compatibility
    getReconciledRecords(search) {
      this.bankValidationChecking = true;
      this.bankValidationMessage = 'Validating bank reference...';
      this.bankValidationStatus = 'info';

      const data = new FormData();
      data.append("function", "getReconciledRecords");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", search);
      data.append("preciseSearch", true);

      execute(data, biller)
          .then((res) => {
            this.bankValidationChecking = false;

            if (res.data.success) {
              this.ReconTransactions = res.data.data.ReconTransactions;
              this.reconAmount = parseFloat(this.ReconTransactions[0].amount);

              const invoiceAmount = parseFloat(this.totalBillBalance);

              if (this.reconAmount === invoiceAmount) {
                this.bankValidationStatus = 'success';
                this.bankValidationMessage = `✓ Bank reference found: ${this.ReconTransactions[0].description} | Amount: KES ${this.formatPrice(this.reconAmount)}`;
              } else {
                this.bankValidationStatus = 'error';
                this.bankValidationMessage = `Amount mismatch: Bank shows KES ${this.formatPrice(this.reconAmount)} but invoice total is KES ${this.formatPrice(invoiceAmount)}`;
              }
            } else {
              this.ReconTransactions = [];
              this.reconAmount = null;
              this.bankValidationStatus = 'error';
              this.bankValidationMessage = res.data.message || 'The transaction code has not been uploaded from the bank.';
            }
          })
          .catch((e) => {
            this.bankValidationChecking = false;
            this.bankValidationStatus = 'error';
            this.bankValidationMessage = e.message || 'Error validating bank reference';
            this.ReconTransactions = [];
            this.reconAmount = null;
          });
    },

    getBills() {
      if(this.billNo === '') {
        alert('Please Enter Bill No');
        return;
      } else {
        if (this.billNo.includes(',')) {
          const billNumbers = this.billNo.split(',').map(bill => bill.trim());
          for (const billNo of billNumbers) {
            this.processBill(billNo);
          }
          return billNumbers;
        } else {
          this.processBill(this.billNo);
          return [this.billNo];
        }
      }
    },

    processBill(billNo){
      if(billNo === ''){
        alert('Please Enter Bill No')
      }else {
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);
        execute(data,biller)
            .then((res) =>{
              this.billInfo = [];
              if (res.data.success) {
                this.billDetails = res.data.data.billDetails;
                this.billInfo = res.data.data.billInfo;
                const invoiceExists = this.invoices.some(invoice => invoice.billDetails.id === res.data.data.billDetails.id);
                if (!invoiceExists) {
                  this.invoices.push(res.data.data);
                } else {
                  console.log('Invoice already exists!');
                }
                this.totalsInvoicesSummary()
              }else{
                this.message = res.data.message
              }
            })
            .catch((e) => {
              this.message = e.message
            });
      }
    },

    totalsInvoicesSummary(){
      this.totalBillBalance = this.invoices.reduce((total, invoice) => {
        return total + parseFloat(invoice.billDetails.billBalance || 0);
      }, 0);

      this.totalDetailAmount = this.invoices.reduce((total, invoice) => {
        return total + parseFloat(invoice.billDetails.detailAmount || 0);
      }, 0);

      this.totalReceiptAmount = this.invoices.reduce((total, invoice) => {
        return total + parseFloat(invoice.billDetails.receiptAmount || 0);
      }, 0);

      this.billNumbers = this.invoices.map(invoice => invoice.billDetails.billNo).join(', ');

      this.paymentData.amount = this.totalBillBalance;
      this.paymentData.accNo = this.billNumbers;
      this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
      this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
      this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");
    },

    clearInvoices(){
      this.invoices = [];
      this.autoSearchProcessed = false;
      this.bankTransactions = []; // Clear bank transactions too
      this.completedPayments = [];
      this.totalsInvoicesSummary();
    },

    showPaymentMethod(){
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;
      // Reset multi-payment state
      this.isProcessingMultiplePayments = false;
      this.currentProcessingIndex = 0;
      this.currentProcessingStatus = '';
      this.completedPayments = [];
    },

    printBill(billNo){
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({
          receiptNo: this.receiptDetails.receiptNo
        });
        const routeData = this.$router.resolve({name: 'receipt'});
        window.open(routeData.href, '_blank');
      }
    },

    showTransactionSummary(paymentMode){
      this.paymentData.paymentMode = paymentMode;

      if(paymentMode === "MPESA") {
        if (this.phoneNumber == null || this.phoneNumber === '') {
          alert("Enter phone number");
          return;
        }
      }

      if(paymentMode === "BANK") {
        // Skip validation for privileged users
        if (!this.isPrivilegedUser) {
          if (this.bankTransactions.length === 0) {
            alert("Please add at least one bank reference");
            return;
          }

          if (!this.canProceedWithBank) {
            alert(this.bankHelpText);
            return;
          }
        }

        // Validate value date for bank payments only
        if (this.canSetValueDate && this.paymentData.valueDate) {
          this.validateValueDate(this.paymentData.valueDate);
          if (this.valueDateError) {
            alert(`Invalid value date: ${this.valueDateError}`);
            return;
          }
        }
      }

      if(paymentMode === "E-CITIZEN") {
        if (this.paymentData.eCitizenReceiptNo == null) {
          alert("Enter E-CITIZEN Receipt No");
          return;
        }
      }

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
    },

    // NEW: Enhanced makePayment method with multi-bank support
    async makePayment() {
      if(this.paymentData.paymentMode === "MPESA") {
        if (this.phoneNumber == null || this.phoneNumber === '') {
          alert("Enter phone number");
          return;
        }
        // Use existing MPESA flow
        this.processMpesaPayment();
        return;
      }

      if(this.paymentData.paymentMode === "BANK") {
        if (this.bankTransactions.length === 0) {
          alert("No bank transactions to process");
          return;
        }

        // Final value date validation for bank payments only
        if (this.canSetValueDate && this.paymentData.valueDate) {
          this.validateValueDate(this.paymentData.valueDate);
          if (this.valueDateError) {
            alert(`Cannot proceed: ${this.valueDateError}`);
            return;
          }
        }

        // Determine processing strategy based on number of bank transactions
        if (this.bankTransactions.length === 1) {
          // Single bank transaction for one or multiple invoices
          // Backend's processBulkPayment will handle allocation across invoices
          await this.processSingleBankForMultipleInvoices();
        } else {
          // Multiple bank transactions - process sequentially
          await this.processMultipleBankPayments();
        }
        return;
      }

      if(this.paymentData.paymentMode === "E-CITIZEN") {
        if (this.paymentData.eCitizenReceiptNo == null) {
          alert("Enter E-CITIZEN Receipt No");
          return;
        }
        // Use existing E-CITIZEN flow
        this.processEcitizenPayment();
        return;
      }
    },

    // NEW: Process single bank transaction for one or multiple invoices
    async processSingleBankForMultipleInvoices() {
      this.isProcessingMultiplePayments = true;
      this.currentProcessingIndex = 0;
      this.currentProcessingStatus = 'Processing payment...';
      this.message = "Processing bank payment...";

      const txn = this.bankTransactions[0];

      // Prepare payment data - accNo contains all invoice numbers (comma-separated)
      const singlePaymentData = {
        ...this.paymentData,
        bankReceiptNo: txn.refNo,
        amount: txn.amount, // Use the validated bank amount
        paymentMode: 'BANK'
      };

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(singlePaymentData));
      data.append("bulkPayment", "true");

      console.log('Processing single bank payment for invoices:', this.paymentData.accNo);
      console.log('Bank Ref:', txn.refNo, 'Amount:', txn.amount);

      let stream = biller;
      if (this.paymentData.accNo.startsWith("SBP")) {
        stream = trade;
      } else if (this.paymentData.accNo.startsWith("PKN")) {
        stream = parking;
      } else if (this.paymentData.accNo.startsWith("RNT")) {
        stream = rent;
      }

      try {
        const res = await execute(data, stream);

        if (res.data.success) {
          this.currentProcessingStatus = 'Waiting for confirmation...';

          // Wait for payment confirmation
          const result = await this.waitForPaymentConfirmationAsync();

          if (result.success) {
            this.completedPayments.push({
              refNo: txn.refNo,
              receiptNo: result.receiptNo,
              amount: txn.amount
            });

            // Set receipt details
            this.receiptDetails.receiptNo = result.receiptNo;
            this.receiptDetails.receiptAmount = txn.amount;
            this.receiptDetails.billNo = this.billNumbers;

            this.isProcessingMultiplePayments = false;
            this.message = null;
            this.transactionSummary = false;
            this.transactionCompleted = true;
          } else {
            throw new Error(result.message || 'Payment confirmation failed');
          }
        } else {
          throw new Error(res.data.message || 'Payment request failed');
        }
      } catch (error) {
        console.error('Error processing bank payment:', error);
        this.message = `Error: ${error.message}`;
        this.isProcessingMultiplePayments = false;
      }
    },

    // NEW: Promise-based wait for payment confirmation
    waitForPaymentConfirmationAsync() {
      return new Promise((resolve) => {
        const maxAttempts = 12; // 36 seconds total
        let attempts = 0;

        const checkInterval = setInterval(() => {
          attempts++;
          this.currentProcessingStatus = `Confirming payment... (${attempts}/${maxAttempts})`;

          const data = new FormData();
          data.append("function", "checkPayment");
          data.append("accountRef", this.paymentData.accNo);

          execute(data, biller)
              .then((res) => {
                if (res.data.success) {
                  clearInterval(checkInterval);
                  const receiptNo = res.data.data.receipt?.receiptDetails?.receiptNo || 'N/A';
                  resolve({
                    success: true,
                    receiptNo: receiptNo,
                    data: res.data
                  });
                } else if (attempts >= maxAttempts) {
                  clearInterval(checkInterval);
                  resolve({
                    success: false,
                    message: 'Payment confirmation timed out. Please check payment status manually.'
                  });
                }
              })
              .catch((e) => {
                if (attempts >= maxAttempts) {
                  clearInterval(checkInterval);
                  resolve({
                    success: false,
                    message: e.message || 'Error checking payment status'
                  });
                }
              });
        }, 3000);
      });
    },

    // NEW: Process multiple bank payments sequentially
    async processMultipleBankPayments() {
      this.isProcessingMultiplePayments = true;
      this.currentProcessingIndex = 0;
      this.completedPayments = [];
      this.message = "Processing payments...";

      for (let i = 0; i < this.bankTransactions.length; i++) {
        this.currentProcessingIndex = i;
        const txn = this.bankTransactions[i];

        try {
          this.currentProcessingStatus = `Processing ${txn.refNo}...`;

          // Get current bill balance before processing
          if (i > 0) {
            // Refresh invoice details to get updated balance
            await this.refreshInvoiceDetails();
            this.currentProcessingStatus = `Posting payment for ${txn.refNo}...`;
          }

          // Process this payment
          const result = await this.processSingleBankPayment(txn, i);

          if (result.success) {
            this.completedPayments.push({
              refNo: txn.refNo,
              receiptNo: result.receiptNo,
              amount: txn.amount
            });
            this.currentProcessingStatus = `✓ ${txn.refNo} completed`;
          } else {
            throw new Error(result.message || 'Payment failed');
          }

        } catch (error) {
          console.error(`Error processing payment ${i + 1}:`, error);
          this.message = `Error processing ${txn.refNo}: ${error.message}`;
          this.isProcessingMultiplePayments = false;

          // If some payments succeeded, show partial completion
          if (this.completedPayments.length > 0) {
            this.message = `Processed ${this.completedPayments.length} of ${this.bankTransactions.length} payments. Error on ${txn.refNo}: ${error.message}`;
          }
          return;
        }
      }

      // All payments completed successfully
      this.isProcessingMultiplePayments = false;
      this.message = null;

      // Set the receipt details for the last payment
      if (this.completedPayments.length > 0) {
        const lastPayment = this.completedPayments[this.completedPayments.length - 1];
        this.receiptDetails.receiptNo = lastPayment.receiptNo;
        this.receiptDetails.receiptAmount = this.totalBankAmount;
        this.receiptDetails.billNo = this.billNumbers;
      }

      this.transactionSummary = false;
      this.transactionCompleted = true;
    },

    // NEW: Process a single bank payment
    async processSingleBankPayment(txn, index) {
      return new Promise((resolve, reject) => {
        // Prepare payment data for this specific transaction
        const singlePaymentData = {
          ...this.paymentData,
          bankReceiptNo: txn.refNo,
          amount: txn.amount,
          paymentMode: 'BANK'
        };

        const data = new FormData();
        data.append("function", "makePayment");
        data.append("paymentData", JSON.stringify(singlePaymentData));
        data.append("bulkPayment", "true");

        // Log for audit purposes
        console.log(`Processing bank payment ${index + 1}/${this.bankTransactions.length}:`, txn.refNo, txn.amount);

        let stream = biller;
        if (this.paymentData.accNo.startsWith("SBP")) {
          stream = trade;
        } else if (this.paymentData.accNo.startsWith("PKN")) {
          stream = parking;
        } else if (this.paymentData.accNo.startsWith("RNT")) {
          stream = rent;
        }

        execute(data, stream)
            .then((res) => {
              if (res.data.success) {
                // Wait for payment confirmation
                this.waitForPaymentConfirmation(resolve, reject);
              } else {
                reject(new Error(res.data.message || 'Payment request failed'));
              }
            })
            .catch((e) => {
              reject(e);
            });
      });
    },

    // NEW: Wait for payment confirmation (for sequential processing)
    waitForPaymentConfirmation(resolve, reject) {
      const maxAttempts = 12; // 36 seconds total (12 * 3 seconds)
      let attempts = 0;

      const checkInterval = setInterval(() => {
        attempts++;

        const data = new FormData();
        data.append("function", "checkPayment");
        data.append("accountRef", this.paymentData.accNo);

        execute(data, biller)
            .then((res) => {
              if (res.data.success) {
                clearInterval(checkInterval);
                const receiptNo = res.data.data.receipt?.receiptDetails?.receiptNo || 'N/A';
                resolve({
                  success: true,
                  receiptNo: receiptNo,
                  data: res.data
                });
              } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                reject(new Error('Payment confirmation timed out'));
              }
            })
            .catch((e) => {
              if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                reject(e);
              }
            });
      }, 3000);
    },

    // NEW: Refresh invoice details to get updated balance
    async refreshInvoiceDetails() {
      return new Promise((resolve, reject) => {
        const billNo = this.invoices[0]?.billDetails?.billNo;
        if (!billNo) {
          resolve();
          return;
        }

        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        execute(data, biller)
            .then((res) => {
              if (res.data.success) {
                // Update the invoice in our list
                this.invoices[0] = res.data.data;
                this.totalsInvoicesSummary();
              }
              resolve();
            })
            .catch((e) => {
              console.error('Error refreshing invoice:', e);
              resolve(); // Continue even if refresh fails
            });
      });
    },

    // Existing MPESA payment flow
    processMpesaPayment() {
      this.message = "Payment Request sent";
      this.paymentData.phoneNumber = this.phoneNumber;

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));
      data.append("bulkPayment", "true");

      let stream = biller;
      if (this.paymentData.accNo.startsWith("SBP")) {
        stream = trade;
      } else if (this.paymentData.accNo.startsWith("PKN")) {
        stream = parking;
      } else if (this.paymentData.accNo.startsWith("RNT")) {
        stream = rent;
      }

      execute(data, stream)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.startPaymentCheck();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    // Existing E-CITIZEN payment flow
    processEcitizenPayment() {
      this.message = "Processing E-CITIZEN payment...";

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));
      data.append("bulkPayment", "true");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.startPaymentCheck();
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    // Enhanced checkPayment with timeout control
    checkPayment() {
      const currentTime = Date.now();
      const elapsedTime = currentTime - this.paymentCheckStartTime;

      if (elapsedTime >= this.paymentTimeoutDuration) {
        this.handlePaymentTimeout();
        return;
      }

      const randomNumber = Math.floor(Math.random() * 3) + 1;
      const remainingTime = Math.ceil((this.paymentTimeoutDuration - elapsedTime) / 1000);

      if(randomNumber === 1){
        this.message = `Waiting for payment. (${remainingTime}s remaining)`;
      }
      if(randomNumber === 2){
        this.message = `Waiting for payment.. (${remainingTime}s remaining)`;
      }
      if(randomNumber === 3){
        this.message = `Waiting for payment... (${remainingTime}s remaining)`;
      }

      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.handlePaymentSuccess(res);
            }
          })
          .catch((e) => {
            console.error("Payment check error:", e.message);
          });
    }
  }
}
</script>


<style scoped>
.value-date-section {
  border: 1px solid #e3e6f0;
  border-radius: 0.5rem;
  padding: 1rem;
  background-color: #f8f9fc;
}

.badge-warning {
  background-color: #f6c23e !important;
  color: #fff !important;
}

.font-14px {
  font-size: 14px;
}

.font-21 {
  font-size: 21px;
}

.font-16px {
  font-size: 16px;
}

.font-size-48 {
  font-size: 48px;
}

.text-blink-primary {
  color: #4e73df;
}

.bg-primary-blink {
  background-color: #4e73df;
}

.border-2 {
  border-width: 2px !important;
}

.border-solid {
  border-style: solid !important;
}

.border-radius {
  border-radius: 0.5rem;
}

.flip-x {
  transform: scaleX(-1);
}

/* NEW: Multi-bank transaction styles */
.bank-transactions-list {
  max-height: 300px;
  overflow-y: auto;
}

.bank-transaction-item {
  background-color: #f8f9fc;
  transition: all 0.2s ease;
}

.bank-transaction-item:hover {
  background-color: #eaecf4;
}

.add-bank-transaction {
  border-style: dashed !important;
  border-color: #d1d3e2 !important;
}

.totals-summary {
  background-color: #f8f9fc;
}

.processing-progress {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.completed-payments-summary .table {
  font-size: 0.85rem;
}
</style>